import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface AttendanceMonth {
  month: string;
  present: number;
  absent: number;
}

export interface AttendanceRangeSummaryResponse {
  success: boolean;
  startDate: string;
  endDate: string;
  data: AttendanceMonth[];
}

const fetchAttendanceSummary = async (
  startDate: string,
  endDate: string
): Promise<AttendanceRangeSummaryResponse> => {
  const { data } = await customAxios.get<AttendanceRangeSummaryResponse>(
    `/reports/attendance/yearSummary?startDate=${startDate}&endDate=${endDate}`
  );
  return data;
};

export const useGetAttendanceSummaryRange = (
  startDate?: string,
  endDate?: string
) =>
  useQuery<AttendanceRangeSummaryResponse, AxiosError>(
    ["attendance-summary", startDate, endDate],
    () => fetchAttendanceSummary(startDate as string, endDate as string),
    {
      enabled: Boolean(startDate && endDate),
      onError: (error) =>
        showNotification({
          title: "Error Loading Attendance Summary",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to load attendance summary",
          color: "red",
        }),
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
    }
  );
